/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface FieldEditor { 
    editorType: string;
    hideInSeamlessInline: boolean;
    fieldId: string;
    structId: string;
    showIf?: string;
    showIfValue?: string;
    showResource?: boolean;
    position: number;
    scope?: string;
    displayField?: string;
    textEditorType?: FieldEditor.TextEditorTypeEnum;
}
export namespace FieldEditor {
    export type TextEditorTypeEnum = 'TEXT_AREA' | 'TEXT_FIELD';
    export const TextEditorTypeEnum = {
        TextArea: 'TEXT_AREA' as TextEditorTypeEnum,
        TextField: 'TEXT_FIELD' as TextEditorTypeEnum
    };
}


